import { Select } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import { clsx } from 'clsx';
import { useFormContext } from 'react-hook-form';

import { TGetStartedDataDE } from './GetStartedDE';
import styles from './GetStartedDE.module.css';
import { LOAN_PURPOSE_OPTIONS_DE } from './loanOptions';
import { useLocale } from '../../../hooks/useLocale';

const LoanPurposeDE = () => {
  const { i18n } = useLocale();
  const { t } = useLingui();

  const {
    register,
    formState: { errors },
  } = useFormContext<TGetStartedDataDE>();

  return (
    <Select
      {...register('loanPurpose')}
      label={t`What do you want to use the loan for?`}
      placeholder={t`Please select`}
      className={clsx({
        [styles.erroredSelect]: errors.loanPurpose?.message,
      })}
      error={errors.loanPurpose?.message}
    >
      {LOAN_PURPOSE_OPTIONS_DE.map((option) => (
        <option key={option.value} value={option.value}>
          {i18n._(option.label)}
        </option>
      ))}
    </Select>
  );
};

export default LoanPurposeDE;
